<prod-push-info></prod-push-info>

<!-- Build Mode Toggle
<div class="build-mode-container" *ngIf="environmentName !== 'test' && authService.hasPermission(['push'], 'GamedataController')">
  <div class="build-mode-toggle">
    <label class="toggle-label">
      <i class="pi pi-cog" style="margin-right: 8px;"></i>
      Build Mode:
    </label>
    <p-inputSwitch 
      [(ngModel)]="isFullBuild" 
      [trueValue]="true" 
      [falseValue]="false"
      styleClass="build-mode-switch">
    </p-inputSwitch>
    <span class="toggle-description">
      {{ isFullBuild ? 'Full Build (Complete Gamedata Rebuild)' : 'Partial Build (Fast Update)' }}
    </span>
  </div>
</div> -->

<!-- DEV, QA, DEV + QA buttons (only show when not in test environment) -->
<div class="gamedata-buttons-container" *ngIf="environmentName !== 'test'">
  <div class="gamedata-buttons-grid">
    <!-- Main action buttons -->
    <div class="gamedata-button-item" *ngIf="environmentName !== 'development' && authService.hasPermission(['push'], 'GamedataController')">
      <button pButton type="button" label="DEV" class="dev-button gamedata-btn" (click)="onGameDataBuildV3('dev')"></button>
    </div>
    <div class="gamedata-button-item" *ngIf="(environmentName === 'development' || environmentName === 'local') && authService.hasPermission(['push'], 'GamedataController')">
      <button pButton type="button" label="TEST" class="qa-button gamedata-btn" (click)="onGameDataBuildV3('test')"></button>
    </div>
    <div class="gamedata-button-item" *ngIf="(environmentName === 'production' || environmentName === 'local') && authService.hasPermission(['push'], 'GamedataController')">
      <button pButton type="button" label="QA" class="qa-button gamedata-btn" (click)="onGameDataBuildV3('stage')"></button>
    </div>
    <div class="gamedata-button-item" *ngIf="(environmentName === 'production' || environmentName === 'local') && authService.hasPermission(['push'], 'GamedataController')">
      <button pButton type="button" label="DEV + QA" class="devqa-button gamedata-btn" (click)="showConfirmModal()"></button>
    </div>
    
    <!-- Cancel button -->
    <div class="gamedata-button-item" *ngIf="authService.hasPermission(['delete'], 'GamedataController')">
      <button pButton type="button" label="Cancel PUSH" class="cancel-push-button gamedata-btn" (click)="cancelPush()"></button>
    </div>
  </div>
</div>

<!-- Build Mode Toggle for TEST environment -->
<div class="build-mode-container" *ngIf="environmentName === 'test' && authService.hasPermission(['push'], 'GamedataController')">
  <div class="build-mode-toggle">
    <label class="toggle-label">
      <i class="pi pi-cog" style="margin-right: 8px;"></i>
      Build Mode:
    </label>
    <p-inputSwitch 
      [(ngModel)]="isFullBuild" 
      [trueValue]="true" 
      [falseValue]="false"
      styleClass="build-mode-switch">
    </p-inputSwitch>
    <span class="toggle-description">
      {{ isFullBuild ? 'Full Build (Complete Gamedata Rebuild)' : 'Partial Build (Fast Update)' }}
    </span>
  </div>
</div>

<!-- TEST button (only show in test environment) -->
<div class="gamedata-buttons-container test-environment" *ngIf="environmentName === 'test'">
  <div class="gamedata-buttons-grid">
    <!-- TEST button -->
    <div class="gamedata-button-item" *ngIf="authService.hasPermission(['push'], 'GamedataController')">
      <button pButton pRipple type="button" label="TEST" class="qa-button gamedata-btn" 
              [disabled]="isLoading || !cmsSettings.manualQAGamedataPushEnabled" 
              (click)="onGameDataBuildV3('test')">
      </button>
    </div>
    
    <!-- Cancel button -->
    <div class="gamedata-button-item" *ngIf="authService.hasPermission(['delete'], 'GamedataController')">
      <button pButton type="button" label="Cancel PUSH" class="cancel-push-button gamedata-btn" (click)="cancelPush()"></button>
    </div>
  </div>
</div>

<!-- Confirmation Dialog for DEV + QA -->
<p-dialog header="Build DEV + QA Gamedata V3" [(visible)]="displayConfirmModal" [modal]="true" [closable]="true" [style]="{ width: '40vw' }">
  <div class="ui-g ui-fluid">
    <div class="ui-g-12">
      <p style="font-size: 1.1em; margin-bottom: 1em;">
        <i class="pi pi-exclamation-triangle" style="font-size: 2em; color: #FBC02D; vertical-align: middle; margin-right: 10px;"></i>
        Are you sure that you want to Build Dev and QA Gamedata V3? QA Build Gamedata will only be executed if Dev gamedata build was successful.
      </p>
    </div>
    <div class="ui-g-12 text-center button-group-modal">
      <button pButton type="button" label="No" icon="pi pi-times" class="ui-button-secondary no-button" (click)="cancelBuild()"></button>
      <button pButton type="button" label="Yes" icon="pi pi-check" class="ui-button-primary yes-button" (click)="confirmBuild()"></button>
    </div>
  </div>
</p-dialog>

<!-- Spinner -->
<ngx-spinner bdColor="rgba(36,34,36,0.8)" size="medium" color="#81c784" type="pacman">
  <p style="font-size: 20px; color: white">Loading...</p>
</ngx-spinner>